import type { ManipulateType } from 'dayjs';

export enum PeriodTypeEnum {
    NONE = 'NONE',
    DAY = 'DAY',
    WEEK = 'WEEK',
    WEEK2 = 'WEEK2',
    MONTH = 'MONTH'
}

export interface NextDepositTime {
    num: number;
    type: ManipulateType;
}

export interface PeriodOption {
    label: string;
    value: PeriodTypeEnum;
    nextDepositTime: NextDepositTime | null;
}
